import { push } from 'connected-react-router';
import envConfig from '../../../config';
import { paths } from '../../../routes/paths';
import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { ReservationById } from '../api-types';

export const name: string = 'reservations';

export const types = {
    GET_RESERVATION: name + '/GET_RESERVATION',
    FIND_RESERVATION: name + '/FIND_RESERVATION',
    CREATE_RESERVATION: name + '/CREATE_RESERVATION',
    EDIT_RESERVATION: name + '/EDIT_RESERVATION',
    SPLIT_RESERVATION: name + '/SPLIT_RESERVATION',
    CANCEL_RESERVATION: name + '/CANCEL_RESERVATION',
    CANCEL_RESERVATION_CALL_CENTER: name + '/CANCEL_RESERVATION_CALL_CENTER', //With charge if needed
    DELETE_RESERVATION_RECURRENT: name + '/DELETE_RESERVATION_RECURRENT',
};

interface ReservationState {
    reservations: ReservationById;
}

const initialState: ReservationState = {
    reservations: {} as ReservationById,
};

const reducer = (state = initialState, action): ReservationState => {
    const payload = action.payload;
    const parameters = action.parameters;
    const id = parameters ? parameters.id : 0;

    switch (action.type) {
        case types.GET_RESERVATION:
            return {
                ...state,
                reservations: { ...state.reservations, [id]: payload },
            };
        // case types.CANCEL_RESERVATION:
        //     return {
        //         ...state,
        //         reservations: { ...state.reservations, [id]: payload }, // Not consistent with get
        //     };
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    getReservation: (id) =>
        fetchAction(
            CoreAPIService.get(`internal/backoffice/reservations/${id}`, null, null, envConfig.privapi_url),
            types.GET_RESERVATION,
            { id },
        ),
    findReservation: (number: string, callback) =>
        fetchAction(
            CoreAPIService.get(`/core/reservations/search?id=${number}`),
            types.FIND_RESERVATION,
            {},
            {
                success: (dispatch, response) => {
                    if (callback) {
                        callback(response.payload);
                    }
                },
            },
        ),
    createReservation: (payload, callback?) =>
        fetchAction(
            CoreAPIService.post(`/core/reservations/add`, payload),
            types.CREATE_RESERVATION,
            {},
            {
                success: (dispatch, response) => {
                    if (callback) {
                        callback(response.payload);
                    }
                },
            },
        ),
    editReservation: (id, payload, callback?) =>
        fetchAction(
            CoreAPIService.put(`/core/reservations/${id}`, payload),
            types.EDIT_RESERVATION,
            {},
            {
                success: (dispatch) => {
                    dispatch(push(`${paths.reservations}/${id}`));
                },
            },
        ),
    cancelReservation: (id, payload, callback?) =>
        fetchAction(
            CoreAPIService.post(`/core/reservations/${id}/cancel`, payload),
            types.CANCEL_RESERVATION,
            { id },
            {
                success: (dispatch, response) => {
                    if (callback) {
                        callback(response.payload);
                    }
                },
            },
        ),
    splitReservation: (id, callback?) =>
        fetchAction(
            CoreAPIService.put(`/core/reservations/${id}/split`, {}),
            types.SPLIT_RESERVATION,
            { id },
            {
                success: (dispatch, response) => {
                    if (callback) {
                        callback(response.payload);
                    }
                },
            },
        ),
    cancelReservationCallCenter: (payload: { uuid: string; phonenumber: string }, callback?) =>
        fetchAction(
            CoreAPIService.delete(`/core/ride`, { ...payload, isBooking: false }),
            types.CANCEL_RESERVATION_CALL_CENTER,
            {},
            { success: callback },
        ),
    deleteReservationRecurrent: (id, callback) =>
        fetchAction(
            CoreAPIService.delete(`/core/recurrents/${id}`),
            types.DELETE_RESERVATION_RECURRENT,
            { id },
            {
                success: callback,
            },
        ),
};

const localState = (state: any): ReservationState => state[name] || initialState;
export const selectors = {
    reservations: (state) => localState(state).reservations,
};
